import { CrossIcon } from "@t8891/icon";
import { formatNumberToUnitString } from "@t8891/utils";
import React from "react";

const BuyCarLarge: React.FC<any> = ({ data, visible, setVisible }) => {
  const { url, menuCount, strongTitle, strongBtnTitle } = data;

  if (!visible) {
    return <></>;
  }
  return (
    <div
      className='w-[210px] h-[61px] rounded-4 px-8 pt-12 pb-8 flex flex-col justify-between relative'
      style={{ background: "linear-gradient(90deg,#ffffff, #dde5ff)" }}
    >
      <CrossIcon
        className='absolute right-6 top-6'
        size={12}
        fill='#333'
        onClick={() => {
          setVisible(false);
        }}
      />
      <div className='ellipsis text-14 font-semibold text-[#333]'>{strongTitle}</div>
      <div className='flex items-center justify-between'>
        <div className='text-12 text-[#999999] flex items-center'>
          已有
          <span className='text-[#3264FF]'>
            {formatNumberToUnitString(Number(menuCount), { needLocalString: true, needToThousand: true })}
          </span>
          位車主分享
        </div>
        <a
          target='_blank'
          id='buycar-large-btn'
          className='px-8 flex items-center justify-center h-24 leading-24 bg-[#ff4333] rounded-4 text-12 text-[#fff] hover:text-[#fff]'
          href={url}
        >
          {strongBtnTitle}
        </a>
      </div>
    </div>
  );
};

export default BuyCarLarge;
